/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_CustomInputs */

const en_us2_workout_logging_bar_custom = /** @type {(inputs: Workout_Logging_Bar_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_br2_workout_logging_bar_custom = /** @type {(inputs: Workout_Logging_Bar_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra`)
};

const es_419_workout_logging_bar_custom = /** @type {(inputs: Workout_Logging_Bar_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otra`)
};

const pt_pt2_workout_logging_bar_custom = /** @type {(inputs: Workout_Logging_Bar_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outra`)
};

const fr_fr2_workout_logging_bar_custom = /** @type {(inputs: Workout_Logging_Bar_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_de2_workout_logging_bar_custom = /** @type {(inputs: Workout_Logging_Bar_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere`)
};

const it_it2_workout_logging_bar_custom = /** @type {(inputs: Workout_Logging_Bar_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Workout_Logging_Bar_CustomInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_custom = /** @type {((inputs?: Workout_Logging_Bar_CustomInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_CustomInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_custom(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_custom(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_custom(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_custom(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_custom(inputs)
	return en_us2_workout_logging_bar_custom(inputs)
});
export { workout_logging_bar_custom as "workout-logging.bar_custom" }